import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { Suspense, useContext } from 'react';
import DaViewer from '../../DaEditor/components/Viewer/Viewer';
import { Image } from '../PluginComponents/Image';
import { Gallery } from '../PluginComponents/Gallery';
import { ThemeContext } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { DaEditorContext } from '../../Context/DaEditorContext';
const BaseViewer = (_param)=>{
    var { fixedParagraph: fixedParagraphFromProps } = _param, restProps = _object_without_properties(_param, [
        "fixedParagraph"
    ]);
    const isMobile = useContext(MobileContext);
    const contextTheme = useContext(ThemeContext);
    // Never fixed for mobile
    const fixedParagraph = isMobile ? false : fixedParagraphFromProps;
    return /*#__PURE__*/ React.createElement(Suspense, {
        fallback: null
    }, /*#__PURE__*/ React.createElement(DaEditorContext.Provider, {
        value: true
    }, /*#__PURE__*/ React.createElement(DaViewer, _object_spread({
        imageComponent: Image,
        galleryComponent: Gallery,
        isDarkTheme: contextTheme === 'dark',
        fixedParagraph: fixedParagraph
    }, restProps))));
};
BaseViewer.displayName = 'BaseViewer';
export default BaseViewer;

//# sourceMappingURL=Base.js.map